import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
// import Container from '@material-ui/core/Container';
import Button from "components/CustomButtons/Button";
import compose from "recompose/compose";
import { withRouter } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import SecSummary from "./SecSummary";

import store from "store";

const styles = (theme) => ({
  boxborder: {
    border: "2px solid #ddd",
    fontSize: "12px",
    padding: "12px",
    fontWeight: "bold",
  },
  heading: {
    textAlign: "center",
    fontWeight: 900,
    lineHeight: 1.1,
  },
  subHeading: {
    fontWeight: 700,
    lineHeight: 1.1,
  },
  proceed: {
    color: "#fff",
    backgroundColor: "#337ab7",
    borderColor: "#2e6da4",
    padding: ".5% 7%",
    width: "max-content",
  },
  newgridsep: {
    minHeight: theme.spacing.unit * 1,
  },
  examHeading: {
    color: "white",
    backgroundColor: "#2d70b6",
    padding: "5px 0",
    fontWeight: 900,
    // minHeight: theme.spacing(9)
  },
  tablelines: {
    color: "#555",
    border: "1px solid #ddd",
    borderCollapse: "collapse",
    padding: "10px",
    overflowX: "scroll",
  },
  box: {
    // minHeight: theme.spacing(3),
    marginTop: theme.spacing.unit * 1,
    padding: theme.spacing.unit * 1,
  },
  renderWhite: {
    minHeight: "50%",
    padding: "10%",
  },
});
class ExamSummaryAdv extends React.Component {
  checkedFlag = false;
  type = "SUMMARY";
  constructor(props) {
    super(props);
    this.props = props;
    this.submitExam = this.submitExam.bind(this);
    this.type = "SUMMARY";
    this.state = {
      user: store.get("user") ? store.get("user") : {},
    };
  }

  submitExam(val) {
    if (val) {
      this.props.submit("YES");
    } else {
      this.props.submit("NO");
    }
  }
  viewResult() {
    console.log("view");
    this.type = "VIEW_RESULT";
    this.props.submit("VIEW_RESULT");
  }
  componentDidUpdate() {
    // eslint-disable-next-line

    switch (this.props.type) {
      case "RESULT":
      case "VIEW_RESULT":
        this.type = this.props.type;
        break;
    }
  }
  // proceed() {
  //     const { history } = this.props;
  //     if (!this.checkedFlag) {
  //         alert('Please accept terms and conditions before proceeding.');
  //     } else {
  //         history.push('/exam-portal', { ...this.props.location.state });
  //     }
  // }
  render() {
    const { classes } = this.props;
    const props = this.props;
    return (
      <React.Fragment>
        {/* <Grid item xs={12} className={classes.newgridsep}></Grid> */}
        <GridContainer style={{ background: "white" }} justify="center">
          <GridItem xs={12} className={classes.examHeading}>
            <Typography
              component="h4"
              variant="h5"
              style={{ color: "white", padding: "1% 10%", fontWeight: "bold" }}
            >
              JEE ADVANCE
            </Typography>
          </GridItem>
          {(() => {
            switch (this.type) {
              case "SUMMARY":
                return (
                  <React.Fragment>
                    <GridItem xs={12}>
                      <h3 variant="h5" className={classes.heading}>
                        Exam Summary
                      </h3>
                    </GridItem>

                    <GridItem
                      xs={12}
                      className={classes.heading}
                      style={{
                        textAlign: "-webkit-center",
                        overflowX: "auto",
                        padding: "8px",
                      }}
                    >
                      {/* <GridContainer className={classes.box} style={{ textAlign: '-webkit-center' }}> */}
                      <Table>
                        <TableHead>
                          {/* <tr className={classes.tablelines}> */}
                          <TableCell
                            className={classes.tablelines}
                            style={{ borderBottomWidth: "2px" }}
                          >
                            {" "}
                            Section Name
                          </TableCell>
                          <TableCell
                            className={classes.tablelines}
                            style={{ borderBottomWidth: "2px" }}
                          >
                            {" "}
                            No of Questions{" "}
                          </TableCell>
                          <TableCell
                            className={classes.tablelines}
                            style={{ borderBottomWidth: "2px" }}
                          >
                            {" "}
                            Answered
                          </TableCell>
                          <TableCell
                            className={classes.tablelines}
                            style={{ borderBottomWidth: "2px" }}
                          >
                            {" "}
                            Not Answered
                          </TableCell>
                          <TableCell
                            className={classes.tablelines}
                            style={{ borderBottomWidth: "2px" }}
                          >
                            {" "}
                            Marked for Review
                          </TableCell>
                          <TableCell
                            className={classes.tablelines}
                            style={{ borderBottomWidth: "2px" }}
                          >
                            {" "}
                            Answered & Marked for Review(will be considered for
                            evaluation)
                          </TableCell>
                          <TableCell
                            className={classes.tablelines}
                            style={{ borderBottomWidth: "2px" }}
                          >
                            {" "}
                            Not Visited
                          </TableCell>
                          {/* </tr> */}
                        </TableHead>
                        <TableBody>
                          <tr>
                            <td className={classes.tablelines}>JEE ADVANCE</td>
                            <td className={classes.tablelines}>
                              {this.props.statusdisplay.ANSWERED +
                                this.props.statusdisplay.NOT_ANSWERED +
                                this.props.statusdisplay.MARKED_FOR_REVIEW +
                                this.props.statusdisplay
                                  .ANSWERED_MARKED_FOR_REVIEW +
                                this.props.statusdisplay.NOT_VISITED}
                            </td>
                            <td className={classes.tablelines}>
                              {this.props.statusdisplay.ANSWERED}
                            </td>
                            <td className={classes.tablelines}>
                              {this.props.statusdisplay.NOT_ANSWERED}
                            </td>
                            <td className={classes.tablelines}>
                              {this.props.statusdisplay.MARKED_FOR_REVIEW}
                            </td>
                            <td className={classes.tablelines}>
                              {
                                this.props.statusdisplay
                                  .ANSWERED_MARKED_FOR_REVIEW
                              }
                            </td>
                            <td className={classes.tablelines}>
                              {this.props.statusdisplay.NOT_VISITED}
                            </td>
                          </tr>
                        </TableBody>
                      </Table>
                      {/* </GridContainer> */}
                    </GridItem>
                    <GridItem xs={12}>
                      <br />
                      <h3 variant="h5" className={classes.heading}>
                        Subject and Section Wise Summary
                      </h3>
                    </GridItem>

                    <GridItem
                      xs={12}
                      sm={10}
                      style={{ overflowX: "auto", padding: "8px" }}
                    >
                      <br /> <br />
                      <Table>
                        <TableHead>
                          <TableCell className={classes.boxborder}>
                            Section Name
                          </TableCell>
                          <TableCell className={classes.boxborder}>
                            No. of Questions
                          </TableCell>
                          <TableCell className={classes.boxborder}>
                            Answered
                          </TableCell>
                          <TableCell className={classes.boxborder}>
                            Not Answered
                          </TableCell>
                          <TableCell className={classes.boxborder}>
                            Marked for Review
                          </TableCell>

                          <TableCell className={classes.boxborder}>
                            {" "}
                            Answered & Marked for Review(will be considered for
                            evaluation)
                          </TableCell>
                          <TableCell className={classes.boxborder}>
                            {" "}
                            Not Visited
                          </TableCell>
                        </TableHead>
                        <TableBody>
                          {Object.keys(props.schema.sections).map((section) => (
                            <SecSummary
                              schema={props.schema}
                              questions={this.props.questions}
                              section={section}
                              subject={"PHYSICS"}
                            />
                          ))}
                          {Object.keys(props.schema.sections).map((section) => (
                            <SecSummary
                              schema={props.schema}
                              questions={this.props.questions}
                              section={section}
                              subject={"CHEMISTRY"}
                            />
                          ))}
                          {Object.keys(props.schema.sections).map((section) => (
                            <SecSummary
                              schema={props.schema}
                              questions={this.props.questions}
                              section={section}
                              subject={"MATHEMATICS"}
                            />
                          ))}
                        </TableBody>
                      </Table>
                    </GridItem>
                    <GridItem xs={12}>
                      <br /> <br />
                      {/* <GridContainer className={classes.box}> */}
                      <Typography variant="h6" className={classes.heading}>
                        Are you sure you want to submit for final marking?
                        <br />
                        No changes will be allowed after submission.
                      </Typography>
                      {/* </GridContainer> */}
                    </GridItem>
                    <Grid item xs={12}>
                      <Typography variant="h6" className={classes.heading}>
                        <Button
                          onClick={() => {
                            this.type = "RECORD";
                            this.forceUpdate();
                          }}
                          className="btn-next"
                        >
                          YES
                        </Button>
                        <Button
                          onClick={() => this.submitExam(false)}
                          className="btn-next"
                        >
                          NO
                        </Button>
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <GridContainer className={classes.renderWhite} />
                    </Grid>
                  </React.Fragment>
                );
              case "RECORD":
                return (
                  <React.Fragment>
                    <GridItem xs={12}>
                      {/* <GridContainer className={classes.box}> */}
                      <h3 className={classes.heading}>
                        Thank You, your responses will be submitted for final
                        marking - click OK to complete final submission.
                      </h3>
                      {/* </GridContainer> */}
                    </GridItem>
                    <GridItem xs={12}>
                      <Typography variant="h6" className={classes.heading}>
                        <button
                          onClick={() => this.submitExam(true)}
                          className="btn-next"
                        >
                          Ok
                        </button>
                        <button
                          onClick={() => this.submitExam(false)}
                          className="btn-next"
                        >
                          Cancel
                        </button>
                      </Typography>
                    </GridItem>
                    <Grid item xs={12}>
                      <GridContainer className={classes.renderWhite} />
                    </Grid>
                  </React.Fragment>
                );
              case "RESULT":
                return (
                  <React.Fragment>
                    <GridItem xs={12}>
                      {/* <GridContainer className={classes.box}> */}
                      <h3 className={classes.heading}>
                        Thank you, Submitted Successfully.
                      </h3>
                      {/* </GridContainer> */}
                    </GridItem>
                    {this.state.user && (
                      <Fragment>
                        {this.state.user.instituteId !==
                          "5ea3572fe301133d0a73e9e0" && (
                          <GridItem item xs={12}>
                            <h5 className={classes.heading}>
                              <button
                                onClick={this.viewResult.bind(this)}
                                className="btn-next"
                              >
                                View result
                              </button>
                            </h5>
                          </GridItem>
                        )}
                      </Fragment>
                    )}

                    <Grid item xs={12}>
                      <GridContainer className={classes.renderWhite} />
                    </Grid>
                  </React.Fragment>
                );
              // eslint-disable-next-line
            }
          })()}
        </GridContainer>
      </React.Fragment>
    );
  }
}

export default compose(
  withRouter,
  withStyles(styles)
)(ExamSummaryAdv);
